module.exports = __webpack_public_path__ + "media/images/preview_recipe_2_thumb-41a69c9567e4728eaddf54e17c315dc1.webp";